<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <v-btn @click="goBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
            Назад
          </v-btn>
        </v-col>
        <v-col cols="12">
          {{ isEditing ? 'Редактирование партнера' : 'Добавление партнера' }}
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.name" label="Наименование" dense required></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.email" label="Почта" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.phone" label="Номер телефона" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.bin" label="БИН" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.address" label="Адрес" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.link" label="Ссылка" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-file-input
                  v-model="photo"
                  label="Логотип"
                  truncate-length="15"
                  dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.cityId" :items="cities" item-value="id" item-text="name" label="Город" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.visible" :items="selects" label="Видимость партнера" dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-textarea v-model="form.description" label="Описание"></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-btn class="mt-4" @click="addPartner" color="primary">
        {{ isEditing ? 'Обновить' : 'Добавить'}}
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>

import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'TireAdd',
  data () {
    return {
      selects: ['Да', 'Нет'],
      valid: true,
      form: {
        name: '',
        email: '',
        phone: '',
        address: '',
        link: '',
        description: '',
        visible: '',
        bin: '',
        cityId: ''
      },
      photo: null,
      cities: []
    }
  },
  mounted() {
    this.getCities()
    this.getPartnerInfo()
  },
  computed: {
    isEditing () {
      return !!this.$route.params.id
    },
    getPartnerId () {
      return this.$route.params.id
    }
  },
  methods: {
    getPartnerInfo () {
      if (this.isEditing) {
        this.$store.dispatch('adminController/getPartnerById', this.getPartnerId).then((response) => {
          this.form = {
            name: response.name,
            email: response.email,
            phone: response.phone,
            address: response.address,
            link: response.link,
            description: response.description,
            visible: response.visible,
            bin: response.bin,
            cityId: response.city.id,
            id: response.id
          }
        })
      }
    },
    getCities () {
      this.$store.dispatch('adminController/getCities').then((response) => {
        this.cities = response;
      })
    },
    goBack () {
      this.$router.go(-1);
    },
    async addPartner () {
      if (this.isEditing) {
        try {
          await this.$store.dispatch('adminController/updatePartner', this.form)
          showSnackbar({
            message: "Парнер успешно добавлен!",
            color: "success",
            timeout: 3000,
          })
        } catch (e) {
          showSnackbar({
            message: "Не удалось добавить парнера!",
            color: "error",
            timeout: 3000,
          })
        }
      } else {
        try {
          const formData = new FormData()
          formData.append('name', this.form.name)
          formData.append('email', this.form.email)
          formData.append('phone', this.form.phone)
          formData.append('address', this.form.address)
          formData.append('link', this.form.link)
          formData.append('description', this.form.description)
          formData.append('bin', this.form.bin)
          formData.append('cityId', this.form.cityId)
          formData.append('visible', this.form.visible === 'Да')
          formData.append('logo', this.photo)
          await this.$store.dispatch('adminController/createPartner', formData)
          showSnackbar({
            message: "Парнер успешно добавлен!",
            color: "success",
            timeout: 3000,
          })
        } catch (e) {
          showSnackbar({
            message: "Не удалось добавить парнера!",
            color: "error",
            timeout: 3000,
          })
        } finally {
          this.goBack()
        }
      }
    }
  }
}
</script>
<style scoped>

</style>